import { render, staticRenderFns } from "./SpecialInspectsBindList.vue?vue&type=template&id=f0ac225a&scoped=true&"
import script from "./SpecialInspectsBindList.vue?vue&type=script&lang=js&"
export * from "./SpecialInspectsBindList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ac225a",
  null
  
)

export default component.exports